import { render } from "./PaRam.vue?vue&type=template&id=0ff8ea1b"
import script from "./PaRam.vue?vue&type=script&lang=js"
export * from "./PaRam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__